import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
import { Chip } from '../Chip/Chip';
import { ChipCloseButton } from '../Chip/ChipCloseButton';
import { ChipContainer } from '../Chip/ChipContainer';
import { ChipLabel } from '../Chip/ChipLabel';
import { RenderIf } from '../RenderIf/RenderIf';
const RemovableChip = ({ name, onRemove, isDisabled }) => {
    const tokens = useTokens();
    return (React.createElement(ChipContainer, { "data-testid": "removable_chip", mt: tokens.Spacing03 },
        React.createElement(Chip, { isDisabled: isDisabled },
            React.createElement(ChipLabel, { "data-testid": "chip_label" }, name),
            React.createElement(RenderIf, { condition: !!onRemove && !isDisabled },
                React.createElement(ChipCloseButton, { chipLabel: name, onClick: onRemove })))));
};
export default RemovableChip;
